// apps/web/src/utils/firebaseAuth.ts
import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { clearAllRmsStopSession } from "./rmsStop";

// ★ ここで「必ず」Firebase App を用意する（初期化済みなら getApp）
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ここで一回だけ auth を作って共有する
const auth = getAuth(app);

// ★ Firestore クライアントをここで作る
export const db = getFirestore(app);

// 「今ログインしてるか」を安全に取る用
export function getIdToken(): Promise<string | null> {
    // すでに currentUser がいる場合（ログイン直後とか）
    if (auth.currentUser) {
        return auth.currentUser.getIdToken();
    }

    // ページリロード直後など、currentUser がまだ null のとき
    return new Promise((resolve) => {
        const unsub = onAuthStateChanged(auth, async (user) => {
            unsub(); // 一回だけで解除
            if (!user) {
                resolve(null);
                return;
            }
            const token = await user.getIdToken();
            resolve(token);
        });
    });
}

// ログアウト用
export async function logout(tenantId?: string): Promise<void> {
    console.log("★ firebaseAuth: logout", {
        tenantIdParam: tenantId,
        localStorageSelectedTenant: localStorage.getItem("selectedTenant"),
        auth_provider: localStorage.getItem("auth_provider"),
    });

    // ✅ ログアウトログ記録（バックグラウンド、失敗してもシグナスしない）
    const selectedTenant = tenantId || localStorage.getItem("selectedTenant") || "ecvision";
    const uid = auth.currentUser?.uid;
    const email = auth.currentUser?.email;

    console.log("★ firebaseAuth: about to log", { selectedTenant, uid, email });

    fetch("/api/auth/logs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            event_type: "logout",
            tenantId: selectedTenant,
            uid: uid || null,
            email: email || null,
            provider: localStorage.getItem("auth_provider") || "firebase",
        }),
    }).catch((e) => {
        console.warn("[auth/logs] failed to log logout:", e?.message);
    });

    // RN-283: ログインし直したら、止まっている店舗はもう一度初期設定を経由させる（ヘッダーとサイドバーのどちらのログアウトでも）
    clearAllRmsStopSession();

    await auth.signOut();
}
